<div class="legal-page">

    <!-- HERO -->
    <section class="legal-hero">
        <div class="legal-container">

            <div class="legal-eyebrow">SPEKWO, LLC · LEGAL</div>

            <h1>Terms &amp; Conditions</h1>

            <p class="legal-date">UPDATED AS OF JANUARY 1, 2025</p>

            <div class="legal-divider"></div>

            <p class="legal-intro">
                SpeKwo, LLC. ("SpeKwo", "we", "us", "our"), GRANTS YOU ACCESS TO ITS WEBSITE, ACCESSIBLE VIA SPEKWO.COM
                (THE "SITE") CONDITIONED ON YOUR ACCEPTANCE OF THE TERMS, CONDITIONS AND NOTICES CONTAINED HEREIN (THE
                "TERMS OF USE") TOGETHER WITH OUR PRIVACY POLICY AND ANY OTHER DOCUMENTS REFERRED TO HEREIN. FOR THE
                PURPOSES OF THESE TERMS OF USE, "SERVICES" MEANS ANY SERVICES OR PRODUCTS PROVIDED BY SPEKWO THROUGH
                THE SITE; AND "CONTENT" MEANS, COLLECTIVELY, ANY TEXT, IMAGES, GRAPHICS, SOFTWARE, SOURCE CODE, APPS,
                SPECIFICATIONS, AUDIO FILES, VIDEOS, ARTICLES, TRADEMARKS, LOGOS AND OTHER INFORMATION OR CONTENT
                AVAILABLE THROUGH THE SITE THAT ARE NOT SUBMISSIONS (AS THAT TERM IS DEFINED BELOW), INCLUDING BUT NOT
                LIMITED TO THE DESIGN, STRUCTURE, SELECTION, COORDINATION, EXPRESSION, AND ARRANGEMENT OF SUCH CONTENT.
            </p>

            <!-- 01 -->
            <h2 class="legal-section-heading">
                <span class="section-num">01</span>
                <span>Acceptance of Terms</span>
            </h2>

            <p class="legal-body">
                PLEASE READ THESE TERMS OF USE AND SPEKWO'S PRIVACY POLICY CAREFULLY. BY CLICKING A REGISTRATION OR
                NEW ACCOUNT SUBMISSION BUTTON, OR BY OTHERWISE USING THE SERVICES OR ACCESSING ANY CONTENT PROVIDED BY
                US THROUGH THE SERVICES, OR USING THE SITE, ON ANY COMPUTER, MOBILE PHONE, TABLET, CONSOLE OR OTHER
                DEVICES, YOU AGREE TO THESE TERMS OF USE, AND YOU CONSENT TO THE COLLECTION, USE AND DISCLOSURE OF
                INFORMATION AS DESCRIBED IN THESE TERMS OF USE AND OUR PRIVACY POLICY. IF YOU DO NOT AGREE TO THESE
                TERMS OF USE AND THE TERMS AND CONDITIONS OF OUR PRIVACY POLICY, YOU MUST EXIT THE SITE IMMEDIATELY AND
                DISCONTINUE ANY USE OF THE SITE, THE SERVICES AND ANY OF ITS CONTENT. YOUR USE OF THE SITE AND SERVICES
                SHALL BE DEEMED TO BE YOUR AGREEMENT TO ABIDE BY EACH OF THE TERMS SET FORTH BELOW. SPEKWO CAN CHANGE
                THESE TERMS OF USE AT ANY TIME BY POSTING UPDATED TERMS OF USE ON THE SITE OR BY SENDING REGISTERED
                USERS AN EMAIL NOTICE OF THE CHANGES. IF ANY MODIFICATION IS UNACCEPTABLE TO YOU, YOU SHALL CEASE USING
                THE SITE AND THE SERVICES. IF YOU DO NOT CEASE USING THESE SITE, YOU WILL BE DEEMED TO HAVE ACCEPTED
                THE CHANGE. These Terms of Use do not alter in any way the terms or conditions of any other agreement
                you may have with SpeKwo or its affiliates for other products or services.
            </p>

            <p class="legal-body">
                Our Privacy Policy, which is incorporated into these Terms of Use by this reference, further describes
                the collection and use of information on this Site. Notwithstanding anything else to the contrary
                contained in these Terms of Use, SpeKwo's use of any personally identifiable information (name, etc.)
                you provide via the Site shall be governed by our Privacy Policy. For further information regarding
                SpeKwo's protection of your personal information, please refer to our privacy policy.
            </p>

            <p class="legal-body">
                You are expected to check this page from time to time to take notice of any changes SpeKwo made, as
                they are binding on you. These Terms of Use were updated as of January 1, 2025.
            </p>

            <!-- 02 -->
            <h2 class="legal-section-heading">
                <span class="section-num">02</span>
                <span>Use and Restrictions. Text Message / SMS Terms</span>
            </h2>

            <p class="legal-body"><strong>SPEKWO, LLC SMS TERMS AND CONDITIONS</strong></p>

            <ul class="legal-list">
                <li>
                    <strong>SMS Consent Communication:</strong> The information as phone numbers obtained as part of
                    the SMS consent process will not be shared with third parties for marketing purposes.
                </li>
                <li>
                    <strong>Types of SMS Communications:</strong> If you have consented to receive text messages from
                    SPEKWO, LLC, you may receive messages related to the following: appointment reminders, reminder to
                    send in your supporting paperwork, quote completed confirmation, follow-up messages.
                </li>
                <li>
                    <strong>Message Frequency:</strong> Message frequency may vary depending on the type of
                    communication. For example, you may receive up to 5 SMS messages per week related to your online
                    request.
                </li>
                <li>
                    <strong>Potential Fees for SMS Messaging:</strong> Please note that standard message and data rates
                    may apply, depending on your carrier's pricing plan. These fees may vary if the message is sent
                    domestically or internationally.
                </li>
                <li>
                    <strong>Opt-In Method:</strong> You may opt-in to receive SMS messages from SPEKWO, LLC by
                    checking the Opt In box on the quote request form.
                </li>
                <li>
                    <strong>Opt-Out Method:</strong> You can opt out of receiving SMS messages at any time. To do so,
                    simply reply "STOP" to any SMS message you receive. Alternatively, you can contact us directly to
                    request removal from our messaging list.
                </li>
                <li>
                    <strong>Help:</strong> If you are experiencing any issues, you can reply with the keyword HELP. Or,
                    you can get help directly from us at www.spekwo.com or call us at 704-626-1776.
                </li>
                <li>
                    <strong>Additional Options:</strong> If you do not wish to receive SMS messages, you can choose not
                    to check the SMS consent box on our forms.
                </li>
                <li>
                    <strong>Standard Messaging Disclosures:</strong> Message and data rates may apply. You can opt-out
                    at any time by texting "STOP." For assistance, text "HELP" or visit our Privacy Policy and Terms
                    and Conditions pages. Message frequency may vary.
                </li>
            </ul>

            <p class="legal-body">
                The Site may be accessed and used only by individuals who can form legally binding contracts under
                applicable laws, who are 18 years of age or older, and who are not barred from using the Sites under
                applicable laws. By agreeing to these Terms of Use, you represent and warrant that: (a) you are at
                least 18 years of age; (b) you have not previously been suspended or removed from the Services; and
                (c) your registration and your use of the Site, the Services and its Content is in compliance with all
                applicable laws and regulations.
            </p>

            <!-- 03 -->
            <h2 class="legal-section-heading">
                <span class="section-num">03</span>
                <span>Prohibited Uses</span>
            </h2>

            <p class="legal-body">BY USING THE SITE, SERVICES AND CONTENT, YOU AGREE NOT TO:</p>

            <ul class="legal-list">
                <li>reproduce, modify, distribute, display or otherwise provide access to, create derivative works from, decompile, disassemble, or reverse engineer any portion of the Site or the Services;</li>
                <li>provide/post/authorize a link to any of the Site or Services from a third-party website;</li>
                <li>remove or modify any copyright or other intellectual property notices that appear in the Site or the Services;</li>
                <li>use the Site or the Services in any way that is unlawful, or harms SpeKwo, its service providers, suppliers, affiliates, or any other user;</li>
                <li>use the Site or Services in any way to discriminate against any individual or class of individuals protected under federal, state or local laws;</li>
                <li>distribute or post spam or other unsolicited messages, chain letters, pyramid schemes, or similar communications through the Site or Services;</li>
                <li>impersonate another person, misrepresent your affiliation with another person or entity, or make any representation to any third party under false pretenses;</li>
                <li>reproduce, publicly display, or otherwise make accessible on or through any other website, application, or service any reviews, ratings, or profile information about any data or Content available through the Site and the Services, except as explicitly permitted by us;</li>
                <li>upload invalid data, viruses, worms, or other software agents to the Site or the Services;</li>
                <li>post, reproduce, publicly display, or otherwise make accessible any content which we, in our sole judgment and discretion, consider illegal, offensive or objectionable;</li>
                <li>interfere with, or compromise the system integrity or security of the Site or Services;</li>
                <li>conduct automated queries (including screen and database scraping, spiders, robots, crawlers, bypassing "captcha" or similar precautions) on the Site or Services;</li>
                <li>access or use any of the Services to develop competitive products or services; or</li>
                <li>attempt to, or permit or encourage any third party to, do any of the above.</li>
            </ul>

            <!-- 04 -->
            <h2 class="legal-section-heading">
                <span class="section-num">04</span>
                <span>Copyright</span>
            </h2>

            <p class="legal-body">
                The Services, Contents and Site as well as the selection and arrangement thereof, are the sole property
                of SpeKwo and/or its licensors and are protected by patent, copyright, trademark and other intellectual
                property laws and may not be used except in accordance with these Terms of Use or with SpeKwo's express
                written consent.
            </p>

            <!-- 05 -->
            <h2 class="legal-section-heading">
                <span class="section-num">05</span>
                <span>Trademark</span>
            </h2>

            <p class="legal-body">
                All trademarks, service marks, trade names, logos and trade dress, whether registered or unregistered
                (collectively the "Marks") that appear on the Services and the Site are proprietary to SpeKwo. You may
                not display or reproduce the Marks other than with the prior written consent of SpeKwo, and you may not
                remove or otherwise modify any trademark notices from any Content.
            </p>

            <p class="legal-body">
                In addition, all page headers, custom graphics, button icons, and scripts are trademarks, service
                marks, trade names and/or trade dress of SpeKwo or their respective owners, and may not be copied,
                imitated, or used, in whole or in part, without the prior written permission of SpeKwo.
            </p>

            <!-- 06 -->
            <h2 class="legal-section-heading">
                <span class="section-num">06</span>
                <span>Intellectual Property</span>
            </h2>

            <p class="legal-body">
                The Site, Services and Content are owned and operated by SpeKwo. The user interfaces, design,
                information, data, code, products, software, graphics, and all other elements of the Site, Services and
                Content (the "SpeKwo Materials") that we provide are protected by intellectual property and other laws
                and are the property of SpeKwo or SpeKwo's third-party licensors. Except as expressly allowed by these
                Terms of Use, you may not make use of the SpeKwo's Materials, and SpeKwo reserve all rights to the
                SpeKwo's Materials, Contents and Services not granted expressly in these Terms of Use.
            </p>

            <!-- 07 -->
            <h2 class="legal-section-heading">
                <span class="section-num">07</span>
                <span>Feedback and Information</span>
            </h2>

            <p class="legal-body">
                If you choose to provide input and suggestions regarding the Site or the Services, including related to
                any of the SpeKwo Materials ("Feedback"), then you hereby grant us an unrestricted, perpetual,
                irrevocable, non-exclusive, fully-paid, royalty-free right to use the Feedback in any manner and for
                any purpose, including the improve the Services or create other products and services.
            </p>

            <!-- 08 -->
            <h2 class="legal-section-heading">
                <span class="section-num">08</span>
                <span>Electronic Communications</span>
            </h2>

            <p class="legal-body">
                You consent to receive electronic communications from SpeKwo either in the form of email sent to you at
                the email address you provide via the Site or by communications posted on the Site for any purpose. You
                acknowledge and agree that any electronic communication in the form of such email or posting on the
                Site shall satisfy any legal requirement that such communication be in writing.
            </p>

            <!-- 09 -->
            <h2 class="legal-section-heading">
                <span class="section-num">09</span>
                <span>Modifications</span>
            </h2>

            <p class="legal-body">
                Any Content offered or posted on the Site is subject to modification or discontinuation at any time and
                from time to time without notice or obligation to you. Without limiting the foregoing, SpeKwo reserves
                the right, in its sole discretion, to charge fees for the use or purchase of, or access to, any
                products, services or Content offered through the Site, at any time and from time to time.
            </p>

            <!-- 10 -->
            <h2 class="legal-section-heading">
                <span class="section-num">10</span>
                <span>Indemnification</span>
            </h2>

            <p class="legal-body">
                You agree to defend, indemnify and hold harmless SpeKwo, its affiliates and their respective directors,
                officers, employees and agents against any losses, liabilities, claims, expenses (including attorney's
                fees) as a result of or related to: (i) any submission that you provide through the Site or your access
                to or use of the Site; (ii) your breach or alleged breach of these Terms of Use; (iii) your violation
                of any third-party right, including without limitation, any intellectual property right, publicity,
                confidentiality, property or privacy right; (iv) your violation of any laws, rules, regulations, codes,
                statutes, ordinances or orders of any governmental and quasi-governmental authorities; or (v) any
                misrepresentation made by you.
            </p>

            <!-- 11 -->
            <h2 class="legal-section-heading">
                <span class="section-num">11</span>
                <span>Links to Third Party Websites</span>
            </h2>

            <p class="legal-body">
                The Site may contain links to websites and other resources operated by third parties other than SpeKwo.
                Such links are provided solely as a convenience to you. SpeKwo does not control such websites, and is
                not responsible for the content, products, services or information offered by any third parties. If you
                decide to access any third party websites or acquire any third party products or services, you do so
                entirely at your own risk.
            </p>

            <!-- 12 -->
            <h2 class="legal-section-heading">
                <span class="section-num">12</span>
                <span>Warranties and Disclaimer</span>
            </h2>

            <p class="legal-body">
                THE SITE, SERVICES, SUBMISSIONS AND ANY CONTENT PROVIDED VIA THE SITE, INCLUDING LINKS, ARE PROVIDED
                ON AN "AS IS" AND "AS AVAILABLE" BASIS WITH NO WARRANTY OF ANY KIND. TO THE MAXIMUM EXTENT PERMITTED
                BY LAW, SPEKWO DISCLAIMS ALL REPRESENTATIONS, WARRANTIES AND CONDITIONS, EXPRESS OR IMPLIED, WITH
                RESPECT TO THE SITE, SUBMISSIONS, THE CONTENT AND ANY PRODUCTS OR SERVICES, INCLUDING, WITHOUT
                LIMITATION, WARRANTIES OR CONDITIONS OF MERCHANTABLE QUALITY, MERCHANTABILITY, DURABILITY, FITNESS FOR
                A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, FREEDOM FROM ERRORS, OMISSIONS, COMPUTER VIRUSES OR
                OTHER MALICIOUS OR UNAUTHORIZED CODE OR PROGRAMS.
            </p>

            <p class="legal-body">Nothing in these Terms of Use shall affect your legal rights under applicable consumer laws.</p>

            <p class="legal-body">
                IN ADDITION, IF A SERVICE OFFERING BECOMES UNAVAILABLE FOR WHATEVER REASON AFTER AN ORDER IS ACCEPTED,
                SPEKWO MAY TERMINATE THE ORDER BY GIVING YOU WRITTEN NOTICE. IN SUCH EVENT, SPEKWO WILL CONTACT YOU TO
                ARRANGE FOR A REFUND IN THE EVENT YOU HAVE PREPAID.
            </p>

            <!-- 13 -->
            <h2 class="legal-section-heading">
                <span class="section-num">13</span>
                <span>Limitation of Liability</span>
            </h2>

            <p class="legal-body">
                SPEKWO AND ITS OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, SUPPLIERS, LICENSORS AND THIRD PARTY PARTNERS
                WILL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, PUNITIVE, INCIDENTAL, EXEMPLARY, MULTIPLIED OR
                CONSEQUENTIAL DAMAGES, LOST PROFITS OR REVENUES OR FAILURE TO REALIZE EXPECTED SAVINGS, OR ANY DAMAGES
                WHATSOEVER, WHETHER OR NOT SUCH PARTY HAS BEEN PREVIOUSLY ADVISED OF THE POSSIBILITY OF SUCH DAMAGES,
                WHETHER UNDER CONTRACT, TORT (INCLUDING NEGLIGENCE) OR ANY OTHER THEORY. REGARDLESS OF THE PREVIOUS
                SENTENCES, IF SPEKWO IS FOUND TO BE LIABLE, SUCH LIABILITY IS LIMITED TO THE GREATER OF THE ACTUAL
                TOTAL AMOUNT RECEIVED BY SPEKWO FROM YOU OR $100.
            </p>

            <p class="legal-body">
                You agree that any claim you may have arising out of or related to your relationship with SpeKwo must
                be filed within one year after such claim arose; otherwise, your claim is permanently barred.
            </p>

            <!-- 14 -->
            <h2 class="legal-section-heading">
                <span class="section-num">14</span>
                <span>Governing Law</span>
            </h2>

            <p class="legal-body">
                All litigation, court proceedings, lawsuits, court hearings and other hearings or actions initiated in
                connection with the Sites and/or the Content must and will be venued exclusively in the state of New
                Mexico. These Terms of Use and the relationship between you and SpeKwo will be governed by the laws of
                the State of New Mexico, without giving effect to principles of conflict of laws of any jurisdiction.
            </p>

            <!-- 15 -->
            <h2 class="legal-section-heading">
                <span class="section-num">15</span>
                <span>Severability</span>
            </h2>

            <p class="legal-body">
                If any provision of these Terms of Use is held to be invalid, illegal or unenforceable in any respect
                under any applicable law or rule in any jurisdiction, such invalidity, illegality or unenforceability
                will not affect the effectiveness or validity of any provision in any other jurisdiction, and these
                Terms of Use will be reformed, construed and enforced in such jurisdiction as if such provision had
                never been contained herein.
            </p>

            <!-- 16 -->
            <h2 class="legal-section-heading">
                <span class="section-num">16</span>
                <span>Guarantee of Pricing</span>
            </h2>

            <p class="legal-body">
                It is important you understand that the service provided by SpeKwo.com is purely for estimation and
                negotiation purposes. We in no way guarantee that the prices we estimate for repairs on your report are
                the same that you will end up paying for that specific repair. Our pricing is based on average cost for
                a similar repair in your area, and due to unknown conditions or underlying issues that we are not privy
                to, actual repair cost may be substantially higher.
            </p>

            <!-- 17 -->
            <h2 class="legal-section-heading">
                <span class="section-num">17</span>
                <span>Product Download</span>
            </h2>

            <p class="legal-body">
                Our products are currently delivered by Internet download only. After your purchase has been approved we
                will process your order. Orders are typically processed within seventy two (72) hours but could take
                longer to complete. Once your order has been processed we will send you a confirmation email using the
                email address you provided on our order form.
            </p>

            <p class="legal-body">
                Downloads from our servers are closely monitored to ensure you are able to successfully access our
                products. While we are flexible and allow you to complete a reasonable number of downloads we will not
                tolerate download abuse. If for any reason after 72 hours you have not received your download email,
                please contact our customer support team immediately at
                <a href="mailto:info@spekwo.com">info&#64;speKwo.com</a>.
            </p>

            <!-- 18 -->
            <h2 class="legal-section-heading">
                <span class="section-num">18</span>
                <span>Refund Policy</span>
            </h2>

            <p class="legal-body">
                We stand behind our products and your satisfaction with them is important to us. However, because our
                products are digital goods delivered via Internet download we generally offer no refunds.
            </p>

            <p class="legal-body">
                Although we use highly sophisticated delivery methods, occasionally your email or Internet provider may
                block, delay or filter your delivery email. Under these circumstances we will categorically not offer a
                refund and the product will be deemed to have been delivered under our 72 hour guarantee. Proof of
                delivery attempt shall serve as proof of product delivery.
            </p>

            <!-- 19 -->
            <h2 class="legal-section-heading">
                <span class="section-num">19</span>
                <span>Entire Agreement</span>
            </h2>

            <p class="legal-body">
                These Terms of Use and our Privacy Policy constitute the entire agreement between you and SpeKwo with
                respect to the Site, and they supersede all prior or contemporaneous communications and proposals,
                whether electronic, oral or written, between you and SpeKwo with respect to the Site.
            </p>

            <!-- 20 -->
            <h2 class="legal-section-heading">
                <span class="section-num">20</span>
                <span>How to Contact SpeKwo</span>
            </h2>

            <p class="legal-body">
                If you wish to contact us to update your information, please feel free to contact us by telephone at
                704-626-1776 or by email at
                <a href="mailto:info@spekwo.com">info&#64;speKwo.com</a>.
            </p>

            <!-- CONTACT CARD -->
            <div class="legal-contact-card">
                <div class="contact-card-label">QUESTIONS?</div>
                <p>
                    Contact speKwo at
                    <a href="mailto:info@spekwo.com"><strong>info&#64;spekwo.com</strong></a>
                    or call
                    <a href="tel:7046261776"><strong>704-626-1776</strong></a>
                    · 19701 Bethel Church Road, Suite 103-119, Cornelius, NC 28031
                </p>
            </div>

        </div>
    </section>

</div>
